const MISSED_IMPORT_RELOAD = 'MISSED_IMPORT_RELOAD';
/**
 * Обработка ситуации, когда клиент обращается к чанку, который уже не актуален в результе деплоя
 * @param retries - количество перезагрузок страницы
 * @returns void
 */
export const errorReload = (retries = 1): void => {
  const errRetries: string | null =
    sessionStorage.getItem(MISSED_IMPORT_RELOAD);

  if (typeof errRetries === 'string') {
    if (parseInt(errRetries) >= retries) {
      sessionStorage.removeItem(MISSED_IMPORT_RELOAD);
      return;
    }

    sessionStorage.setItem(
      MISSED_IMPORT_RELOAD,
      String(parseInt(errRetries) + 1),
    );
  } else {
    sessionStorage.setItem(MISSED_IMPORT_RELOAD, '1');
  }

  window.location.reload();
};
